import { render } from "./SingleIndex.vue?vue&type=template&id=b36f17ee"
import script from "./SingleIndex.vue?vue&type=script&lang=js"
export * from "./SingleIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__